import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';
import { awEntitlementsSettings } from './Base';

export const isAGraphEnabled = () => awEntitlementsSettings.getAGraphConfig?.()?.['awentitlements'] ?? true; // for entitlements, default to true

/**
 * Default exclusion rules for AWEntitlements AGraph/Cloud APIs that reject unknown query params
 */
const AW_ENTITLEMENTS_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: ['/v1/users/info'],
    excludedParams: ['configurationDirectory', 'pkg'],
  },
  {
    urlPrefix: ['/v1/users:batchGet'],
    excludedParams: ['configurationDirectory'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AWEntitlements endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, AW_ENTITLEMENTS_PARAM_EXCLUSION_RULES);
}
